export default function Hero() {
  return (
    <section
      id="top"
      className="relative flex min-h-[560px] w-full items-center overflow-hidden pt-20 md:min-h-[640px]"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20newspaper%20collage%20of%20breaking%20headlines%20with%20bold%20serif%20type%20fragments%2C%20dramatic%20warm%20red%20and%20amber%20spotlight%20beams%20over%20dark%20ink%20background%2C%20abstract%20paper%20texture%20and%20torn%20clippings%20floating%2C%20magazine%20tabloid%20cover%20aesthetic%2C%20moody%20cinematic%20lighting%2C%20rich%20crimson%20and%20gold%20tones%2C%20no%20real%20people%20or%20readable%20text%20content%2C%20artistic%20high-detail%20atmospheric%20composition&width=1600&height=900&seq=melon-hero&orientation=landscape"
        alt="大瓜预警编辑部背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-foreground-950/70" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/60 bg-accent-100/20 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200 backdrop-blur whitespace-nowrap">
          <i className="ri-radar-line text-sm" />
          内部消息 · 知情人士 · 圈内人爆料 · 匿名投稿通道开启
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          大瓜预警
          <span className="block text-accent-400">
            汇集内部消息与知情人士透露
          </span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          想听小道消息、看圈内人独家线索？这里把分散在各处的“瓜”整理成可追踪的线索流——
          每条都标注核实状态，理性吃瓜，不造谣、不传谣。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#latest"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
          >
            看最新热瓜
            <i className="ri-arrow-down-line" />
          </a>
          <a
            href="#submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-megaphone-line" />
            我要匿名投稿
          </a>
        </div>

        <dl className="mt-12 grid w-full grid-cols-3 gap-3 md:gap-6">
          {[
            ["2.4w+", "已整理线索"],
            ["128", "深度核实专题"],
            ["99%", "来源状态标注率"],
          ].map(([num, label]) => (
            <div
              key={label}
              className="rounded-xl border border-background-50/15 bg-background-50/5 px-2 py-3 text-center backdrop-blur"
            >
              <dd className="font-label text-2xl font-bold text-accent-400 md:text-3xl">
                {num}
              </dd>
              <dt className="mt-1 text-xs text-background-100/80">{label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}